import { gql } from '@apollo/client';

// ProductAttributeFilterInput 스키마는 Magento 스키마 변경 전까지 고정값
// 인트로스펙션 쿼리 대신 하드코딩하여 네트워크 요청 제거
export const STATIC_FILTER_INPUTS = {
  __type: {
    inputFields: [
      { name: 'category_id', type: { name: 'FilterEqualTypeInput' } },
      { name: 'category_uid', type: { name: 'FilterEqualTypeInput' } },
      { name: 'created_at', type: { name: 'FilterTypeInput' } },
      { name: 'description', type: { name: 'FilterMatchTypeInput' } },
      { name: 'lw_boot_height', type: { name: 'FilterEqualTypeInput' } },
      { name: 'lw_brand', type: { name: 'FilterEqualTypeInput' } },
      { name: 'lw_color', type: { name: 'FilterEqualTypeInput' } },
      { name: 'lw_features', type: { name: 'FilterEqualTypeInput' } },
      { name: 'lw_gender', type: { name: 'FilterEqualTypeInput' } },
      { name: 'lw_heel_height', type: { name: 'FilterEqualTypeInput' } },
      { name: 'lw_material', type: { name: 'FilterEqualTypeInput' } },
      { name: 'lw_material_clothing', type: { name: 'FilterEqualTypeInput' } },
      { name: 'lw_occasion', type: { name: 'FilterEqualTypeInput' } },
      { name: 'lw_product_usage', type: { name: 'FilterEqualTypeInput' } },
      { name: 'lw_size_apparel_alpha', type: { name: 'FilterEqualTypeInput' } },
      { name: 'lw_size_apparel_kids', type: { name: 'FilterEqualTypeInput' } },
      { name: 'lw_size_shoes_adult', type: { name: 'FilterEqualTypeInput' } },
      { name: 'lw_size_shoes_kids', type: { name: 'FilterEqualTypeInput' } },
      { name: 'lw_size_wader', type: { name: 'FilterEqualTypeInput' } },
      { name: 'lw_toe_shape', type: { name: 'FilterEqualTypeInput' } },
      { name: 'lw_width', type: { name: 'FilterEqualTypeInput' } },
      { name: 'name', type: { name: 'FilterMatchTypeInput' } },
      { name: 'news_from_date', type: { name: 'FilterTypeInput' } },
      { name: 'news_to_date', type: { name: 'FilterTypeInput' } },
      { name: 'placeholder', type: { name: 'FilterEqualTypeInput' } },
      { name: 'price', type: { name: 'FilterRangeTypeInput' } },
      { name: 'quantity_and_stock_status', type: { name: 'FilterEqualTypeInput' } },
      { name: 'serial_name', type: { name: 'FilterMatchTypeInput' } },
      { name: 'short_description', type: { name: 'FilterMatchTypeInput' } },
      { name: 'sku', type: { name: 'FilterEqualTypeInput' } },
      { name: 'skus', type: { name: 'FilterEqualTypeInput' } },
      { name: 'url_key', type: { name: 'FilterEqualTypeInput' } },
    ],
  },
};

export const GET_FILTER_INPUTS = gql`
  query GetFilterInputsForModal {
    __type(name: "ProductAttributeFilterInput") {
      inputFields {
        name
        type {
          name
        }
      }
    }
  }
`;

export const GET_CATEGORY_COUNT = gql`
  query GetCategoriescount($id: String!, $filters: ProductAttributeFilterInput!) {
    categories(filters: { category_uid: { in: [$id] } }) {
      items {
        uid
      }
    }
    products(filter: $filters) {
      total_count
    }
  }
`;

export default {
  getCategoryCountQuery: GET_CATEGORY_COUNT,
  getFilterInputsQuery: GET_FILTER_INPUTS,
};
